import { supportsSetSinkId } from "modules/deviceInfo";
import { useDevices } from "modules/audioVideo/hooks";

export const useDeviceDetection = () => {
  const { speakers, cameras, microphones } = useDevices();

  const isSetSinkIdSupported = supportsSetSinkId();

  const noSpeaker = isSetSinkIdSupported ? speakers.length === 0 : false;

  const isAnyDeviceMissing =
    microphones.length === 0 || noSpeaker || cameras.length === 0;

  return {
    noCam: cameras.length === 0,
    noMic: microphones.length === 0,
    noSpeaker,
    isAnyDeviceMissing,
  };
};
